import { SET_USERPROFILE, CLEAR_USERPROFILE, EDIT_SUCCESS, EDIT_FAIL, SET_MESSAGE} from "./types";
import {editProfile} from '../../service/users.service';

export const setUserProfile = (user) => ({
  type: SET_USERPROFILE,
  payload: user
});

export const clearUserProfile = () => ({
  type: CLEAR_USERPROFILE
});

export const updateProfile = (formData) => (dispatch) => {
  return editProfile(formData).then(
    (response) => {
      dispatch({
        type: EDIT_SUCCESS
      });

      dispatch({
        type: SET_MESSAGE,
        payload: response.data.message
      });

      return Promise.resolve();
    },
    (error) => {
      const message = (error || error.data.message || error.message).toString();

      dispatch({
        type: EDIT_FAIL
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message
      });

      return Promise.reject();
    }
  );
};
